module.exports = __webpack_public_path__ + "static/media/ZoomOut.589bfad1.svg";